import { useState } from "react";
import { get } from "lodash";
import { DocumentTypesEnum } from "../../components/CheckoutTransferSafetypay/infraestructure/DocumentTypesEnum";
export var NUMBER_MASK = "999999999999999";
export var ALPHANUMERIC_MASK = "***************";
var documentNumberMaskByType = function (type) {
    if (type === DocumentTypesEnum.RUT) {
        return ALPHANUMERIC_MASK;
    }
    else {
        return NUMBER_MASK;
    }
};
export var useDocumentNumberMaskState = function () {
    var _a = useState(documentNumberMaskByType()), mask = _a[0], setMask = _a[1];
    var onSelectDocumentType = function (event) {
        var value = get(event, "target.value");
        if (value)
            setMask(documentNumberMaskByType(value));
    };
    return {
        mask: mask,
        onSelectDocumentType: onSelectDocumentType,
    };
};
